<template>
  <div>
    <!-- Invoices dialog -->
    <v-dialog
      v-model="show"
      max-width="350"
    >
      <v-card>
        <v-card-title style="text-align:center">Generate Reports</v-card-title>
        <v-divider></v-divider>
        <v-container fluid>
          <v-row>
            <v-col cols="auto">
              <DatePicker
                v-model="dateForInvoices"
                label="Salary Month"
                type="month"
                dense
              />
            </v-col>
          </v-row>
        <v-card-actions>
          <v-btn small outlined color="primary" @click.prevent="show = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="generateReports">Generate Report</v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- /Invoices dialog -->
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'PayrollReport',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false
    }
  },
  data () {
    return {
      dateForInvoices: new Date(new Date().getFullYear(), new Date().getMonth()).toISOString().substr(0, 7)
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
  },
  methods: {
    generateReports () {
      if (this.show && this.dateForInvoices) {
        const body = {
          From_Date: this.dateForInvoices + '-01'
        }
        this.axios.post('/api/payroll/invoices', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          },
          responseType: 'blob'
        }).then(result => {
          const url = window.URL.createObjectURL(new Blob([result.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `SalaryForEmployee_${this.dateForInvoices}.xlsx`)
          document.body.appendChild(link)
          link.click()
          this.show = false
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
    }
  }
}
</script>
